import { useGtm } from '@gtm-support/vue-gtm'

export const pushGtmDataLayer = (payload) => {
	const gtm = useGtm()

	if (gtm?.enabled()) {
		window.dataLayer?.push(payload)
	}
}

export const useGtmEvent = (
	eventName,
	dataPayload = {},
	optionalPayload = {}
) => {
	const data = {
		event: eventName,
		...dataPayload,
		...optionalPayload,
	}

	pushGtmDataLayer(data)
}
